import { FASTElement as n, attr as l, observable as p } from "@microsoft/fast-element";
import { navItemStyles as u } from "./nav-item.styles.js";
import { navItemTemplate as h } from "./nav-item.template.js";
var f = Object.defineProperty, m = (v, t, s, b) => {
  for (var e = void 0, i = v.length - 1, o; i >= 0; i--)
    (o = v[i]) && (e = o(t, s, e) || e);
  return e && f(t, s, e), e;
};
const r = class r extends n {
  constructor() {
    super(...arguments), this.active = !1, this.subNavItems = [];
  }
  subNavItemsChanged() {
    this.resetSubNavItems();
  }
  navItemClicked() {
    this.$emit("navigate", { url: this.url }), this.toggleNavItem();
  }
  toggleNavItem() {
    this.$emit("toggle-nav-item"), this.active = !this.active;
  }
  toggleSubNavItems(t) {
    this.subNavItems.map((s) => {
      s != t.eventTarget() && (s.active = !1);
    });
  }
  resetSubNavItems() {
    this.subNavItems && !this.active && this.subNavItems.map((t) => {
      t.active = !1;
    });
  }
};
r.definition = {
  name: "nav-item",
  template: h,
  styles: u
};
let a = r;
m([
  l({ mode: "boolean" })
], a.prototype, "active");
m([
  l
], a.prototype, "url");
m([
  p
], a.prototype, "subNavItems");
export {
  a as NavItem
};
